import { Typography } from "@mui/material";

import { useMyLearningProgress } from "../../../../../hooks/useMyLearningProgress";
import { SummaryItem } from "./SummaryItem";

import "./my_progress.scss";

export function MyProgress() {
	const { summaries } = useMyLearningProgress();

	return (
		<div className="right-column-content-container">
			<div className="my-progress-container">
				<Typography className="small-title-text bold title">
					My Progress
				</Typography>

				{summaries.map((summary) => (
					<SummaryItem summary={summary} key={summary.id} />
				))}
			</div>
		</div>
	);
}
